import type { DiffLine } from 'app/components/ops-prompts/lineDiff'

export type DiffBlock = { kind: 'lines'; lines: DiffLine[] } | { kind: 'folded'; lines: DiffLine[] }

/**
 * Keeps each change with `context` unchanged lines around it and folds longer unchanged
 * runs, so a one-paragraph edit to a long prompt reads as the edit, not the whole prompt.
 */
export function foldDiff(lines: DiffLine[], context = 2): DiffBlock[] {
  const keep = lines.map(() => false)
  lines.forEach((line, index) => {
    if (line.type === `context`) return
    for (let near = Math.max(0, index - context); near <= Math.min(lines.length - 1, index + context); near++) {
      keep[near] = true
    }
  })

  const blocks: DiffBlock[] = []
  lines.forEach((line, index) => {
    const kind = keep[index] ? `lines` : `folded`
    const last = blocks[blocks.length - 1]
    if (last?.kind === kind) last.lines.push(line)
    else blocks.push({ kind, lines: [line] })
  })
  return blocks
}
